import { render, staticRenderFns } from "./tortDetectDetail.vue?vue&type=template&id=542359da&scoped=true&"
import script from "./tortDetectDetail.vue?vue&type=script&lang=js&"
export * from "./tortDetectDetail.vue?vue&type=script&lang=js&"
import style0 from "./tortDetectDetail.vue?vue&type=style&index=0&id=542359da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542359da",
  null
  
)

export default component.exports